import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit {
  timePicker: FormGroup = this.fb.group({
    hours: ['06', Validators.required],
    minutes: ['00', Validators.required],
    format: ['AM', Validators.required],
  });

  hours = Array(12);
  minutes = Array(60);
  format = ['AM', 'PM'];
  @Input() label: any = '';
  @Input() selectedTime!: String;
  @Output() time = new EventEmitter();
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.selectedTime) {
      this.setTime();
    }

    this.formatTime();
    this.timePicker.controls['hours'].valueChanges.subscribe((data) => {
      this.formatTime();
    });
    this.timePicker.controls['minutes'].valueChanges.subscribe((data) => {
      this.formatTime();
    });
    this.timePicker.controls['format'].valueChanges.subscribe((data) => {
      this.formatTime();
    });
  }

  setTime() {
    const timeArr = this.selectedTime.split(' : ');
    this.timePicker.get('hours')?.setValue(timeArr[0]);
    this.timePicker.get('minutes')?.setValue(timeArr[1]);
    this.timePicker.get('format')?.setValue(timeArr[2]);
  }

  formatTime() {
    const hours = this.timePicker.controls['hours'].value;
    const minutes = this.timePicker.controls['minutes'].value;
    const format = this.timePicker.controls['format'].value;
    this.time.emit(hours + ' : ' + minutes + ' : ' + format);
  }
}
